module.exports = __webpack_public_path__ + "img/LogoDashboard-26.a1a3471e.svg";